import React, { useEffect, useState } from 'react'
import { Box, Typography, Switch } from '@material-ui/core'
import { connect } from 'react-redux'
import { useStyles } from './style'
import Breadcrumb from '../../Components/Breadcrumbs'
import { Cards } from '../../elements'
import { withStyles } from '@material-ui/core/styles'
import SystemCard from './SystemCard'
import SystemGraph from './SystemGraph'
import SystemTable from './SystemTable'
import { systemsService } from '../../Services/SystemsService/SystemsService'
import _ from 'lodash'
import moment from 'moment'
import { COMMON } from '../../utils/constants'
import * as messageTypes from '../../utils/messageTypes'
import { AppButton, DisplayMessage, Loader } from '../../Components'
import CustomDialog from '../../Components/CustomDialog'
import { programService, eventService } from '../../Services'
import { APPLICATION_APPROVED, APPLICATION_REJECTED, APPLICATION_SUBMITTED, APPLICATION_WITHDRAWN, ENROLLED, FOR_UNENROLLMENT, OFF_GRID, ON_GRID, UNENROLLED } from './constant'
import { OutlinedButton, Popup, TableOutline } from '../../elements'
import ApplicationSubmittedForUnenrollment from '../../elements/icons/SystemUnenrollStatusIcons/applicationSubmittedForUnenrollment'
import Enrolled from '../../elements/icons/SystemUnenrollStatusIcons/enrolled'
import Unenrolled from '../../elements/icons/SystemUnenrollStatusIcons/unenrolled'
import Icon from '../../utils/icons'
import ApplicationStarted from '../../elements/icons/EnrollmentApplictionStatusIcons/applicationStarted'
import ApplicationSubmitted from '../../elements/icons/EnrollmentApplictionStatusIcons/applicationSubmitted'
import ApplicationRejected from '../../elements/icons/EnrollmentApplictionStatusIcons/applicationRejected'
import ApplicationWithdrawn from '../../elements/icons/EnrollmentApplictionStatusIcons/applicationWithdrawn'

const AntSwitch = withStyles((theme) => ({
  switchBase: {
    color: '#F37320',
    '&$checked': {
      color: '#F37320',
    },
    '&$checked + $track': {
      backgroundColor: '#000000',
    },
  },
  checked: {},
  track: {},
}))(Switch)


const statusOptions = [
  { status: 'Enrolled', text: 'Enrolled', icon: <Enrolled /> },
  { status: 'Unenrolled', text: 'Unenrolled', icon: <Unenrolled /> },
  { status: 'Application_Submitted', text: 'Application submitted for unenrollment', icon: <ApplicationSubmittedForUnenrollment /> },
  { status: 'Application Started', text: 'In Progress', icon: <ApplicationStarted /> },
  { status: 'Application Submitted', text: 'Submitted', icon: <ApplicationSubmitted /> },
  { status: 'Application Rejected', text: 'Rejected', icon: <ApplicationRejected /> },
  { status: 'Application Withdrawn', text: 'Withdrawn', icon: <ApplicationWithdrawn /> },
]

function System(props) {
  const classes = useStyles()
  const [state, setState] = useState({
    gridCheck: true,
  })
  const [systemDetails, setSystemDetails] = useState({})
  const [deviceInfo, setDeviceInfo] = useState()
  const [tableData, setTableData] = useState([])
  const [systemData, setSystemData] = useState([])
  const [eventsData, setEventsData] = useState()
  const [open, setOpen] = useState()
  const [message, setMessage] = useState()
  const [messageType, setMessageType] = useState()
  const [showGridModal, setShowGridModal] = useState(false)
  const [switchedTo, setSwitchedTo] = useState(false)
  const [program, setProgram] = useState()
  const [loading, setLoading] = useState(true)
  const [unenrollmentConfirmationPopup, setUnenrollmentConfirmationPopup] = useState(false)
  const [siteSyncPopup, setSiteSyncPopup] = useState(false)
  const [siteSyncSuccess, setsiteSyncSuccess] = useState(false)
  const [congratsPopup, setCongratsPopup] = useState(false)
  const [errorPopup, setErrorPopup] = useState(false)
  const [unenrollmentStatus, setUnenrollmentStatus] = useState('active')
  const [withdrawnPopup, setWithdrawnPopup] = useState(false)
  const [withdrawSuccessPopup, setWithdrawSuccessPopup] = useState(false)
  const [approvalAction, setApprovalAction] = useState('')
  const [approveRejectPopup, setApproveRejectPopup] = useState(false)
  const [unenrollApprovePopup, setUnenrollApprovePopup] = useState(false)
  const [unenrollRejectPopup, setUnenrollRejectPopup] = useState(false)
  const [unenrollmentApplication, setUnenrollmentApplication] = useState({})

  const programId = props?.match?.params?.programId
  const siteId = props?.match?.params?.siteId
  const autoUnenroll = _.get(program, 'feature_flags.auto_unenroll_sites', false)
  const { currentUser } = props

  const getSwitchGridContent = () => {
    return (
      <>
        <Box display="flex" justifyContent="center" alignItems="center" mt={1} mb={5}>
          <Typography className={classes.gridModalText}>Switch the site to {switchedTo ? 'on-grid' : 'off-grid'} mode?</Typography>
        </Box>
        <Box display="flex" justifyContent="space-around">
          <AppButton className={classes.modalButton} text="yes" onClick={() => handleChange()} />
          <AppButton className={classes.modalButton} fill={false} text="no" onClick={() => setShowGridModal(false)} />
        </Box>
      </>
    )
  }

  const handleChange = () => {
    const { currentUser } = props
    setLoading(true)
    const gridCheck = switchedTo
    const mode = switchedTo ? ON_GRID : OFF_GRID
    systemsService.updateGridMode(currentUser.account_id, siteId, mode)
      .then(gridData => {
        setState({ ...state, gridCheck: mode })
        setLoading(false)
        setOpen(true)
        setMessage(`System switched to ${mode}`)
        setMessageType(messageTypes.SUCCESS)
        setShowGridModal(false)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
        setShowGridModal(false)
      })
  }

  const handleSelectChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value })
  }

  const getAllEvents = () => {
    const { currentUser } = props
    setLoading(true)
    eventService.getAllEventsBySiteId(
      programId, currentUser.account_id, siteId, -1, -1, -1
    )
      .then(response => {
        setEventsData(response.events)
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getUnenrollmentApplications = () => {
    setLoading(true)
    systemsService.getApplicationsByType(currentUser.account_id, programId, siteId, FOR_UNENROLLMENT)
      .then(applicationData => {
        if (!_.isEmpty(applicationData)) {
          if (applicationData[0].application_status === APPLICATION_SUBMITTED) {
            setUnenrollmentApplication(applicationData[0])
            setUnenrollmentStatus('pending')
          }
        }
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getSystemDetail = () => {
    const { currentUser } = props
    setLoading(true)
    systemsService.getSystemDetail(currentUser.account_id, programId, siteId)
      .then(systemData => {
        if (_.get(systemData, 'application_status', '') === ENROLLED) {
          getUnenrollmentApplications()
        }
        setLoading(false)
        setSystemDetails(systemData)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getDeviceInfo = () => {
    const { currentUser } = props
    setLoading(true)
    systemsService.getDeviceInfo(currentUser.account_id, siteId)
      .then(deviceData => {
        setLoading(false)
        setDeviceInfo(deviceData)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getTableData = () => {
    const { currentUser } = props
    setLoading(true)
    systemsService.getTableData(currentUser.account_id, programId, siteId)
      .then(systemTableData => {
        setLoading(false)
        setSystemData(systemTableData)
        setSystemTable(systemTableData)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getGridMode = () => {
    const { currentUser } = props
    setLoading(true)
    systemsService.getGridMode(currentUser.account_id, siteId)
      .then(gridModeData => {
        setLoading(false)
        setState({ ...state, gridCheck: gridModeData.grid_state })
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const setSystemTable = (systemTableData) => {
    let systemTable = []
    systemTableData.map(obj => {
      let tableObj = [
        {
          id: 'eventName',
          value: _.get(obj, 'name', ''),
          handleClick: (obj) => { console.log(obj) }
        },
        {
          id: 'eventType',
          value: _.get(obj, 'type', '-'),
        },
        {
          id: 'starttime',
          value: moment(obj.start_time).format('DD-MM-YYYY hh:mm:ss'),
        },
        {
          id: 'endtime',
          value: moment(obj.end_time).format('DD-MM-YYYY hh:mm:ss'),
        },
        {
          id: 'status',
          value: obj['opt-in_status'] ? 'true' : 'false',
        }
      ]
      systemTable.push(tableObj)
    })
    setTableData(systemTable)
  }

  const getProgram = () => {
    const { currentUser } = props
    programService.getProgramsById(currentUser.account_id, programId)
      .then(programData => {
        setProgram(programData)
      })
      .catch(error => {
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const handleApplicationStatusChange = (newStatus) => {
    setLoading(true)
    systemsService.updateApplicationStatus(currentUser.account_id, _.get(unenrollmentApplication, 'application_id', ''), newStatus)
      .then(() => {
        getSystemDetail()
        setLoading(false)
        if (newStatus === APPLICATION_WITHDRAWN) {
          setWithdrawSuccessPopup(true)
        }
        if (newStatus === APPLICATION_APPROVED) {
          setUnenrollApprovePopup(true)
        }
        if (newStatus === APPLICATION_REJECTED) {
          setUnenrollRejectPopup(true)
        }
        setUnenrollmentStatus('active')
        setApproveRejectPopup(false)
        setWithdrawnPopup(false)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const unenrollSite = () => {
    setLoading(true)
    systemsService.unenrollSite(currentUser.account_id, programId, siteId)
      .then(unenrollSiteData => {
        setUnenrollmentConfirmationPopup(false)
        getSystemDetail()
        setUnenrollmentStatus('pending')
        setCongratsPopup(true)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        setUnenrollmentConfirmationPopup(false)
        setErrorPopup(true)
      })
  }

  useEffect(() => {
    getProgram()
  }, [])

  useEffect(() => {
    getSystemDetail()
    getDeviceInfo()
    getAllEvents()
    // getTableData()
  }, [])

  useEffect(() => {
    if (props.isSuperAdmin || _.get(program, 'feature_flags.site_on_grid_off_grid_feature', false)) {
      getGridMode()
    }
  }, [programId, program])

  const renderSystemContent = () => (
    <>
      <SystemCard data={systemDetails} deviceInfo={deviceInfo} program={program} accountId={props.accountId} siteId={siteId} />
      {systemDetails && systemDetails.application_status === ENROLLED && <SystemGraph accountId={props.accountId} siteId={siteId} programId={programId} eventsData={eventsData} timeZone={props.timeZone} />}
    </>
  )

  const renderSystemTable = () => (
    <>
      {systemDetails && systemDetails.application_status && <SystemTable programId={programId} data={systemDetails} />}
    </>
  )

  const getBreadcrumbs = () => {
    let value = [{ 'Home': '/' }, { 'Programs': '/programs' }]
    if (systemDetails && !_.isEmpty(systemDetails)) {
      value.push({ [systemDetails.program_name_admin_ui]: `/programs/${systemDetails.program_id}` })
      value.push({ 'Systems': `/programs/${systemDetails.program_id}/systems` })
      value.push({ [systemDetails.site_id]: '' })
    }
    return value
  }

  const handleMessageClose = (event, reason) => {
    if (reason === COMMON.CLICKAWAY) {
      return
    }

    setOpen(false)
  }

  const renderSiteSyncPopUp = () => {
    return (
      siteSyncSuccess ? <Typography className={classes.popHeader}>Site info synced. Please refresh the page</Typography> : 
      <Typography className={classes.popHeader}>Not able to sync site info. Please contact support</Typography>
    )
  }
  const renderPopupContent = () => {
    return (
      <Box className={classes.popWrapper} px={4}>
        <Box className={classes.popupContentWrapper}>
          <Typography className={classes.popHeader}>
            Are you sure you want to unenroll Site ID: {systemDetails.site_id}?
          </Typography>
          <Typography className={classes.popText}>
            {autoUnenroll ? `Once unenrolled,` : `Unenrollment request would be sent for Enphase Approval. Once approved,`}{` the site would no longer be available for any DR event dispatch.`}
          </Typography>
        </Box>
        <Box className={classes.buttonGroup}>
          <AppButton text='Yes, Unenroll' className={classes.ackButton} onClick={() => unenrollSite()} />
          <AppButton text='No' fill={false} className={classes.ackButton} onClick={() => setUnenrollmentConfirmationPopup(false)} />
        </Box>
      </Box>
    )
  }
  const renderCongratsPopupContent = () => {
    return (
      <Box className={classes.popWrapper}>
        <Icon src="check" />
        <Typography className={classes.popHeader}>
          {autoUnenroll ? `Site Id: ${systemDetails.site_id} successfully unenrolled` : `Unenrollment request is successfully created for Site ID: ${systemDetails.site_id}`}
        </Typography>
        {!autoUnenroll && <Typography className={classes.popText}>Please wait for sometime till unenrollment request gets approved by Enphase.</Typography>}
      </Box>
    )
  }
  const renderErrorPopupContent = () => {
    return (
      <Box className={classes.popWrapper}>
        <Icon src="bigClose" />
        <Typography className={classes.popHeader}>
          Oops! Unenrollment request could not be created.
        </Typography>
        <Box className={classes.buttonGroup}>
          <AppButton text='Retry' className={classes.ackButton} onClick={() => { setErrorPopup(false); unenrollSite() }} />
        </Box>
      </Box>
    )
  }
  const renderWithdrawnPopupContent = () => {
    return (
      <Box className={classes.popWrapper}>
        <Box className={classes.popupContentWrapper}>
          <Typography className={classes.popHeader}>
            Are you sure you want to withdraw unenrollment request for Site ID: {systemDetails.site_id}?
          </Typography>
          <Typography>The site would stand enrolled and no longer be visible in “Unenrollment Requests” section.</Typography>
        </Box>
        <Box className={classes.buttonGroup}>
          <AppButton text='Yes, Withdraw' className={classes.ackButton} onClick={() => { handleApplicationStatusChange(APPLICATION_WITHDRAWN) }} />
          <AppButton text='No' fill={false} className={classes.ackButton} onClick={() => setWithdrawnPopup(false)} />
        </Box>
      </Box>
    )
  }
  const renderWithdrawnSuccessContent = () => {
    return (
      <Box className={classes.popWrapper}>
        <Icon src="check" />
        <Typography className={classes.popHeader}>{'Unenrollment request withdrawn'}</Typography>
        <Typography className={classes.popText}>{`Unenrollment request for Site ID: ${systemDetails.site_id} is successfully withdrawn. Site remains enrolled in ${_.get(program, 'name', '')}.`}</Typography>
      </Box>
    )
  }
  const renderApproveRejectPopupContent = () => {
    return (
      <Box className={classes.popWrapper}>
        <Box className={classes.popupContentWrapper}>
          <Typography className={classes.popHeader}>
            Are you sure you want to {approvalAction} unenrollment request for Site ID: {systemDetails.site_id}?
          </Typography>
          <Typography>{approvalAction === 'approve' ? 'The site would no longer be available for any DR event dispatch and would have to be enrolled again into a Grid Services Program if needed.' :
            `Once rejected, the site would remain enrolled in ${_.get(program, 'name', '')}.`}
          </Typography>
        </Box>
        <Box className={classes.buttonGroup}>
          <AppButton text='Yes' className={classes.ackButton} onClick={() => { handleApplicationStatusChange(approvalAction === 'approve' ? APPLICATION_APPROVED : APPLICATION_REJECTED) }} />
          <AppButton text='No' fill={false} className={classes.ackButton} onClick={() => { setApproveRejectPopup(false) }} />
        </Box>
      </Box>
    )
  }

  const renderUnenrollApprovePopupContent = () => {
    return (
      <Box className={classes.popWrapper}>
        <Icon src="check" />
        <Typography className={classes.popHeader}>
          Unenrollment request approved!
        </Typography>
        <Typography className={classes.popText}>{`Unenrollment request for Site ID: ${systemDetails.site_id} is successfully approved.`}</Typography>
      </Box>
    )
  }

  const renderUnenrollRejectPopupContent = () => {
    return (
      <Box className={classes.popWrapper}>
        <Icon src="bigClose" />
        <Typography className={classes.popHeader}>
          Unenrollment request rejected!
        </Typography>
        <Typography className={classes.popText}>{`Unenrollment request for Site ID: ${systemDetails.site_id} is rejected.`}</Typography>
      </Box>
    )
  }

  const handleSiteSync = () => {
    setLoading(true)
    let details = [siteId]
    const response = systemsService.putSiteSync(currentUser.account_id, details, programId)
    .then(() => {
      setLoading(false)
      setsiteSyncSuccess(true)
      setSiteSyncPopup(true)
    }).catch((error) => {
      setLoading(false)
      setsiteSyncSuccess(false)
      setSiteSyncPopup(true)
    })
  }

  return (
    <Box>
      <Breadcrumb value={getBreadcrumbs()} />
      <Loader loading={loading} />
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={handleMessageClose} />
      <CustomDialog open={showGridModal} title="" fullWidth maxWidth="xs" content={getSwitchGridContent()} handleClose={() => setShowGridModal(false)} />
      <Box className={classes.headerWrapper}>
        <Typography className={classes.title}>
          {siteId ? siteId : 'No Site Selected'}
          {systemDetails && systemDetails.application_status === 'Enrolled' && (props.isSuperAdmin || _.get(program, 'feature_flags.site_on_grid_off_grid_feature', false)) ?
            <span className={classes.switchContainer}>
              {(state.gridCheck === OFF_GRID || state.gridCheck === ON_GRID) ?
                <>
                  <span>Off-Grid</span>
                  <span item>
                    <AntSwitch checked={state.gridCheck === "ON_GRID"} disabled onChange={(e) => { setSwitchedTo(e.target.checked); setShowGridModal(true) }} name="gridCheck" />
                  </span>
                  <span item>On-Grid</span>
                </> :
                <>
                  <AntSwitch disabled name="gridCheck" />
                  <span item>Status Unknown</span>
                </>
              }
            </span> : ''
          }
          <Box className={classes.currentStatus}>
            {unenrollmentStatus === 'pending' && unenrollmentApplication && unenrollmentApplication.application_status ?
              statusOptions.map((statusObj) => (
                unenrollmentApplication?.application_status === statusObj.status && (
                  <Box display='flex' alignItems='center'>
                    <Box display="flex" mr={0.5}>{statusObj.icon}</Box>
                    <Box>{statusObj.text}</Box>
                  </Box>
                )
              )) :
              systemDetails && systemDetails.application_status && (
                statusOptions.map((statusObj) => (
                  systemDetails?.application_status === statusObj.status && (
                    <Box display='flex' alignItems='center'>
                      <Box display="flex" mr={0.5}>{statusObj.icon}</Box>
                      <Box>{statusObj.text}</Box>
                    </Box>
                  )
                ))
              )}
          </Box>
        </Typography>
        {systemDetails && (systemDetails.application_status === ENROLLED || systemDetails.application_status === APPLICATION_SUBMITTED) &&
          <Box display='flex' justifyContent='flex-end'>
            {systemDetails && systemDetails.application_status && (
              statusOptions.map((statusObj) => {
                if (systemDetails.application_status === statusObj.status) {
                  if (props.isAdmin && unenrollmentStatus === 'active') {
                    if (!(program && program.feature_flags && program.feature_flags.openadr_service_enabled && program.feature_flags.openADR_enrollment_service)) {
                      return (
                        <>
                          {props.isSuperAdmin && <AppButton 
                            fill={false}
                            text="Sync Site"
                            className={classes.staticMargin}
                            onClick={handleSiteSync}
                          />}
                          <Box mr={1} />
                          <AppButton
                            fill={false}
                            text="Unenroll"
                            className={classes.staticMargin}
                            onClick={() => { setUnenrollmentConfirmationPopup(true) }}
                          />
                        </>
                      )
                    }
                  } else if (props.isSuperAdmin && !autoUnenroll) {
                    return (
                      <>
                        <AppButton
                          fill={false}
                          text="Withdraw"
                          className={classes.staticMargin}
                          onClick={() => setWithdrawnPopup(true)}
                        />
                        <Box mr={1} />
                        <AppButton
                          fill={false}
                          text="Reject"
                          className={classes.staticMargin}
                          onClick={() => {
                            setApprovalAction('reject')
                            setApproveRejectPopup(true)
                          }}
                        />
                        <Box mr={1} />
                        <AppButton
                          text="Approve"
                          className={classes.staticMargin}
                          onClick={() => {
                            setApprovalAction('approve')
                            setApproveRejectPopup(true)
                          }}
                        />
                      </>
                    )
                  } else {
                    if (props.isAdmin) {
                      return (
                        <AppButton
                          fill={false}
                          text="Withdraw"
                          className={classes.staticMargin}
                          onClick={() => setWithdrawnPopup(true)}
                        />
                      )
                    }
                  }
                }
                return null
              })
            )}
          </Box>
        }
      </Box>
      <Box>
        <CustomDialog open={siteSyncPopup} fullWidth handleClose={() => setSiteSyncPopup(false)} content={renderSiteSyncPopUp()}/>
        <CustomDialog open={unenrollmentConfirmationPopup} fullWidth handleClose={() => setUnenrollmentConfirmationPopup(false)} content={renderPopupContent()} />
        <CustomDialog open={congratsPopup} fullWidth handleClose={() => setCongratsPopup(false)} content={renderCongratsPopupContent()} />
        <CustomDialog open={errorPopup} fullWidth handleClose={() => setErrorPopup(false)} content={renderErrorPopupContent()} />
        <CustomDialog open={withdrawnPopup} fullWidth handleClose={() => setWithdrawnPopup(false)} content={renderWithdrawnPopupContent()} />
        <CustomDialog open={withdrawSuccessPopup} fullWidth handleClose={() => setWithdrawSuccessPopup(false)} content={renderWithdrawnSuccessContent()} />
        <CustomDialog open={approveRejectPopup} fullWidth handleClose={() => setApproveRejectPopup(false)} content={renderApproveRejectPopupContent()} />
        <CustomDialog open={unenrollApprovePopup} fullWidth handleClose={() => setUnenrollApprovePopup(false)} content={renderUnenrollApprovePopupContent()} />
        <CustomDialog open={unenrollRejectPopup} fullWidth handleClose={() => setUnenrollRejectPopup(false)} content={renderUnenrollRejectPopupContent()} />
        <Cards className={classes.cardWrapper} children={renderSystemContent()} />
        <Cards className={classes.cardWrapper} children={renderSystemTable()} />
      </Box>
    </Box>

  )
}

const mapStateToProps = ({ auth }) => {
  const { authUser, currentUser, accountId, isSuperAdmin, isAdmin, timeZone } = auth
  return { authUser, currentUser, accountId, isSuperAdmin, isAdmin, timeZone }
}

export default connect(mapStateToProps, {})(System)